import apiClient from './api';

export interface ImportRowError {
  row: number;
  message: string;
}

export interface ImportResult {
  entity: string;
  totalRows: number;
  importedCount: number;
  failedCount: number;
  errors: ImportRowError[];
}

export type ImportEntity =
  | 'products'
  | 'suppliers'
  | 'customers'
  | 'purchase-items'
  | 'sales-items'
  | 'menu-items'
  | 'recipes';

const IMPORTS_API = '/imports';

export const dataImportService = {
  /** Downloads the IMS CSV template for an entity and triggers a browser save. */
  downloadTemplate: async (entity: ImportEntity) => {
    const response = await apiClient.get(`${IMPORTS_API}/${entity}/template`, {
      responseType: 'blob',
    });

    const disposition = response.headers['content-disposition'] as string | undefined;
    const match = disposition?.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
    const fileName = match?.[1] ?? `ims_${entity.replace(/-/g, '_')}_template.csv`;

    const url = window.URL.createObjectURL(response.data as Blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  /** Uploads a CSV/XLSX file for the entity and returns the row-by-row result. */
  importFile: (entity: ImportEntity, file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return apiClient.post<{ success: boolean; data: ImportResult }>(
      `${IMPORTS_API}/${entity}`,
      formData,
      // Clear the instance JSON default so the browser sets the multipart boundary
      { headers: { 'Content-Type': undefined as unknown as string } }
    );
  },
};
